import {t} from '@eitje/bridge'
import {EitjeButton} from '../../../eitje_button'
import {writeStore} from '../../helpers'
import {useVisibleColumns, useGroupedColumn} from '../../hooks'
import {getTableHeaderFieldName} from '../../components'
import {Select} from '~/components/select'

export const GroupingPicker = ({fields: allTableColumns, defaultVisibleColumns, tableName, recordType, ...rest}) => {
	const savedGrouping = useGroupedColumn({tableName})
	const visibleColumns = useVisibleColumns({tableName, allTableColumns, defaultVisibleColumns})
	const items = visibleColumns?.map(f => mapField(f, tableName, recordType, savedGrouping))

	const handleChange = value => {
		writeStore(tableName, {grouped: value})
	}

	return (
		<Select
			trigger={{
				t: savedGrouping ? `${t('common.group_by')}: ${items.find(item => item.id === savedGrouping)?.name?.toLowerCase()}` : 'table.group',
				'data-intercom-target': 'grouping_picker',
				dropdown: true,
				...rest,
			}}
			items={items}
			value={savedGrouping}
			onChange={handleChange}
			search={{showSearch: true}}
			footerButtons={
				!!savedGrouping?.length && (
					<EitjeButton width="full" iconLeft="unlocked" colorSet="solid" t="table.ungroup" onClick={() => handleChange(null)} />
				)
			}
		/>
	)
}

const mapField = (field, name, recordType) => {
	const _name = getTableHeaderFieldName({name, recordType, field})
	return {id: field, name: _name}
}
